import {Component, EventEmitter, Input, OnDestroy, Output, ViewEncapsulation} from '@angular/core';
import {ResponsiveService} from '../../services/responsive.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'si-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LabelComponent implements OnDestroy {
  @Input() forId: string;
  @Input() text: string;
  @Input() wrapText = false;
  @Input() styleClass: string;
  @Input() tooltipText: string;
  @Input() tooltipStyleClass: string;
  @Input() tooltipEscape = true;
  @Input() forceShowTooltipIcon: boolean;
  @Input() disabled: boolean;
  @Output() tooltipIconClick = new EventEmitter<any>();
  subscriptions: Subscription[] = [];
  isDesktop: boolean;
  private _tooltipPosition = 'top';
  private _tooltipIcon = 'icon-infocircle';

  constructor(private responsiveService: ResponsiveService) {
    this.setResponsiveLogic();
  }

  get tooltipPosition() {
    return this._tooltipPosition;
  }

  @Input()
  set tooltipPosition(val) {
    if (val) {
      this._tooltipPosition = val;
    }
  }

  get tooltipIcon() {
    return this._tooltipIcon;
  }

  @Input()
  set tooltipIcon(val) {
    if (val) {
      this._tooltipIcon = val;
    }
  }

  setResponsiveLogic(): void {
    this.subscriptions.push(
      this.responsiveService.getResponsiveStoreObservable().subscribe(responsiveStore => {
        this.isDesktop = responsiveStore.isDesktop;
      })
    );
  }

  onClickTooltipIcon(event: any): void {
    this.tooltipIconClick.emit(event);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
